import { _axios } from "../../../Utils/Axios/axios";

export const sendUserImageService = async (
  userToken: string,
  userImage: any
) => {
  //
  const data = new FormData();
  data.append("image", userImage);

  return _axios.post("/upload/image", data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
